// extracted by mini-css-extract-plugin
export default {"balances":"OQaG_","balances__text":"_aARM","balances__amount":"I2qqU","balances__currency":"LP_Uw","balances__row":"kaWXn"};